module.exports = __webpack_public_path__ + "static/media/eye.bb6015eb.svg";